// extracted by mini-css-extract-plugin
module.exports = {"receipt-refund-reason":"JCpx-m2vBf1Tsun-7UtPe","truncate-refund-reason":"_3qxHqquJJ8XMWQHsJmM9cv"};